module.exports = __webpack_public_path__ + "assets/b897b2ea67637185d702c1cb91fdd59f.png";